import client from "./client";

const announcementsApi = {
  list(params = {}) {
    return client.get("/announcements", { params }).then(r => r.data);
  },
  create(payload) {
    return client.post("/announcements", payload).then(r => r.data);
  },
  acknowledge(id) {
    return client.patch(`/announcements/${id}/acknowledge`).then(r => r.data);
  },
  markRead(id) {
    return client.patch(`/announcements/${id}/read`).then(r => r.data);
  },
  remove(id) {
    return client.delete(`/announcements/${id}`).then(r => r.data);
  },
  pin(id, pinned) {
    return client.patch(`/announcements/${id}/pin`, { pinned }).then(r => r.data);
  },
};

export default announcementsApi;
